import { __makeTemplateObject } from "tslib";
import { css } from '../../../foundation';
import { RcVirtualizedMenuClasses } from '../utils';
export var VirtualizedMenuStyle = function () {
    // * that is not need be scrollable, we use vl scroll container
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      .", " {\n        max-height: calc(100% - 96px);\n        -webkit-overflow-scrolling: touch;\n        overflow: hidden;\n      }\n    "], ["\n      .", " {\n        max-height: calc(100% - 96px);\n        -webkit-overflow-scrolling: touch;\n        overflow: hidden;\n      }\n    "])), RcVirtualizedMenuClasses.paper);
};
var templateObject_1;
